module.exports = __webpack_public_path__ + "static/img/gptModel71.031ba2cc.png";